const GENERATED_ABI = {};

export { GENERATED_ABI };
